enum FurtherAction
{
	HomeCheckOrdered = 1,
	ContactRequestedReseller = 2,
	ContactRequestedInstaller = 3
}

export default FurtherAction;